export default "__VITE_ASSET__BKijibWM__"